import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, ReplaySubject, tap } from "rxjs";
import { SessionStorageService } from "../common/sessionStorage.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private _user: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _isUserSet: boolean = false;  // Flag to check if user is already set


  constructor(
    private _httpClient: HttpClient,
    private _sessionStorageService: SessionStorageService
  ) {
    // Load user data from session storage on initialization
    const storedUser = this._sessionStorageService.getItem<any>("user");
    if (storedUser) {
      this._user.next(storedUser);
    }
  }

  set user(value: any) {
    // console.log("Setting user:", value);
    // this._sessionStorageService.setItem("user", value);
    this._user.next(value);
    this._isUserSet = true;  // Mark user as set

  }

  get user$(): Observable<any> {
    return this._user.asObservable();
  }

  get(): Observable<any> {
    return this._httpClient.get<any>('api/common/user').pipe(
      tap(user => {
        if (!this._isUserSet) { 
          const storedUser = this._sessionStorageService.getItem<any>("user"); // Only set user if it hasn't been set already
          this._user.next(storedUser);
        }
      })
    );
  }


  update(user: any): Observable<any> {
    return this._httpClient.patch<any>("api/common/user", { user }).pipe(
      tap((response) => {
        const storedUser = this._sessionStorageService.getItem<any>("user"); // Only set user if it hasn't been set already
          this._user.next(storedUser);
      })
    );
  }
}
